import { CoreUrlParams, FilterTypes } from 'Core/interfaces'

export const searchQueryConfig = {
	searchQuery: {
		apiFieldName: null,
		apiSearchFieldName: 'Query',
		filterType: FilterTypes.VALUE,
		UrlParam: CoreUrlParams.searchQuery
	},
	secondarySearchQuery: {
		apiFieldName: null,
		apiSearchFieldName: 'secondaryQuery',
		filterType: FilterTypes.VALUE,
		UrlParam: CoreUrlParams.searchSecondaryQuery
	},
	mainSearchQuery: {
		apiFieldName: null,
		apiSearchFieldName: 'MainSearchQuery',
		filterType: FilterTypes.VALUE,
		UrlParam: CoreUrlParams.mainSearchQuery
	}
}
